import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import ornament from './img/ornament.svg'
import ornament1 from './img/ornament-1.svg'
import ornament2 from './img/ornament-2.svg'
import ornament3 from './img/ornament-3.svg'

import backgroundImg from './img/background.jpg'
import backgroundMobileImg from './img/background-mobile.jpg'

const Intro = ({
  coupleData,
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro369">
      <input
        type="hidden"
        id="anPageName"
        name="page"
        value="animated-intro-large"
      />
      <div className="animated-intro-large animated-intro-small-all-breakpoints screen">
        <img
          className="background-p4EdWL hide-on-320 background"
          src={background || backgroundImg}
          alt="Background"
        />
        <img
          className="background-kaVUlA hide-on-768 background"
          src={background || backgroundMobileImg}
          alt="Background"
        />
        <div className="overlay-p4EdWL overlay-kaVUlA"></div>
        <div className="button-p4EdWL button-kaVUlA">
          <p
            className="site-de-casamento-e-gcDLS5 site-de-casamento-e-CpwLjN"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-gcDLS5 button-CpwLjN">
            <div
              className="pular-introduo-fo8x79 pular-introduo-ZdVp8v"
              onClick={onSkipIntro}
            >
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-initials-p4EdWL couple-initials-kaVUlA">
          <img
            className="ornament-HD8HQr hide-on-320 ornament"
            src={ornament}
            alt="Ornament"
          />
          <img
            className="ornament-r4rExY hide-on-768 ornament"
            src={ornament2}
            alt="Ornament"
          />
          <div className="initials-HD8HQr initials-r4rExY notranslate">
            <div className="e-xTxs68 e-EvGZlL">
              {coupleData?.coupleSimplifiedName.groom &&
                coupleData.coupleSimplifiedName.groom}
            </div>
            <div className="m-EvGZlL m-xTxs68">
              {coupleData?.coupleSimplifiedName.bride}
            </div>
            <img
              className="divider-xTxs68 hide-on-320 divider bp2-animate-enter"
              src={ornament3}
              alt="Divider"
            />
            <img
              className="divider-EvGZlL hide-on-768 divider bp1-animate-enter"
              src={ornament1}
              alt="Divider"
            />
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
